import React, { useState } from "react";
import { Message } from "semantic-ui-react";
import path from "routing/routes/pathMap";
import "./index.css";

const NoSupportedMessage = ({ noSupItem }) => {
    const [hidden, setHidden] = useState(false);

    return (
        <Message
            className="no-supported-message"
            negative
            hidden={hidden}
            onDismiss={() => {
                setHidden(true);
                sessionStorage.setItem("hasBrowserChecked", true);
            }}
        >
            <Message.Header>
                {`Your ${noSupItem} is not currently supported.`}
            </Message.Header>
            <p>
                Rejoin the session from a Google Chrome (version 92 or later).
            </p>
        </Message>
    );
};

const CheckBrowserVersion = () => {
    if (
        sessionStorage.getItem("hasBrowserChecked") ||
        window.location.pathname === path.pages.review_version_details
    )
        return <></>;
    const { userAgent } = navigator;
    const isSupportedBrowser = userAgent.includes("Chrome/");
    if (isSupportedBrowser) {
        const isSupportedVersion =
            userAgent.split("Chrome/")[1].split(".")[0] > 91;
        if (!isSupportedVersion) {
            return <NoSupportedMessage noSupItem="browser version" />;
        } else return <></>;
    } else {
        return <NoSupportedMessage noSupItem="browser" />;
    }
};

export default CheckBrowserVersion;
